module.exports = __webpack_public_path__ + "static/img/47050.bd87103.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/47050.jpg
// module id = Z4R9
// module chunks = 1